import { TableProps } from '@amzn/awsui-components-core';

export const DEFAULT_FILE_NAME = 'Report';
export const DEFAULT_SHEET_NAME = 'Sheet1';

/**
 * Transforms table data into a format suitable for export by mapping column definitions to their values
 * @param data - Array of data objects to be transformed
 * @param columnDefinitions - Array of column definitions that specify the structure of the table
 * @returns Array of objects with column headers as keys and corresponding data values
 * @throws Error if data or columnDefinitions are null/undefined
 * @example
 * const data = [{ id: 1, name: 'John' }];
 * const columns = [
 *   { id: 'id', header: 'ID' },
 *   { id: 'name', header: 'Name' }
 * ];
 * const result = formatTableDataForExport(data, columns);
 * // Returns: [{ 'ID': 1, 'Name': 'John' }]
 */
export const formatTableDataForExport = (data: readonly Record<string, any>[], columnDefinitions: readonly TableProps.ColumnDefinition<any>[]) => {
  try {
    const exportData = data.map((item: Record<string, any>) => {
      if (!item || typeof item !== 'object') {
        throw new Error('Each data item must be a valid object');
      }

      const newItem: Record<string, any> = {};
      columnDefinitions.forEach((column: TableProps.ColumnDefinition<any>) => {
        if (!column) {
          throw new Error('Invalid column definition');
        }

        if (column.id) {
          const key = column.id;
          const headerKey = String(column.header || key);
          // Handle null or undefined values
          newItem[headerKey] = item[key] ?? '';
        }
      });
      return newItem;
    });

    return exportData;
  } catch (error: any) {
    throw new Error(`Failed to format table data: ${error.message}`);
  }
};
